import React, { useContext, useState, useEffect } from "react";
import { Paper, Alert, Box } from "@mui/material";
import ErrorIcon from "@mui/icons-material/Error";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import FileDownloadDoneIcon from "@mui/icons-material/FileDownloadDone";
import { fetchMediaDownload } from "gatsby-frontend";
import { SiteContext } from "gatsby-frontend/src/Site";

function Icon({ type }) {
	return (
		<Box
			sx={(theme) => ({
				textAlign: "center",
				"& .MuiSvgIcon-root": {
					width: "200px",
					height: "200px",
					marginY: theme.spacing(2),
					marginX: "auto",
					color: theme.palette.grey.dark,
				},
			})}
		>
			{type === "loading" && <CloudDownloadIcon className="loading-pulse" />}
			{type === "success" && <FileDownloadDoneIcon />}
			{type === "fail" && <ErrorIcon />}
		</Box>
	);
}

function Download({ id, setError }) {
	const { dispatch, isAuthenticated } = useContext(SiteContext);
	const _loading_msg = ["Downloading file", "info"];
	const [status, setStatus] = useState("loading");
	const [msg, setMsg] = useState(_loading_msg);

	useEffect(() => {
		let _msg;
		switch (status) {
			case "success":
				_msg = ["Download completed", "success"];
				break;
			case "fail":
				_msg = ["An error occurred", "error"];
				break;
			default:
				_msg = _loading_msg;
				break;
		}
		setMsg(_msg);
	}, [status]);

	useEffect(() => {
		(async () => {
			if (id) {
				let _dispatch = isAuthenticated ? dispatch : null;
				let download = await fetchMediaDownload(id, _dispatch);
				if (download) {
					setStatus("success");
					setError(false);
				} else {
					setStatus("fail");
					setError(true);
				}
			} else {
				setStatus("fail");
				setError(true);
			}
		})();
	}, []);
	return (
		<Paper>
			<Icon type={status}></Icon>
			<Alert
				severity={msg[1]}
				sx={(theme) => ({
					justifyContent: "center",
					"& .MuiAlert-icon": {
						display: "none",
					},
					"& .MuiAlert-message": {
						fontSize: theme.typography.fontSizeLg,
						fontWeight: theme.typography.fontWeightBold,
					},
				})}
			>
				{msg[0]}
			</Alert>
		</Paper>
	);
}

export default Download;
